<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách chính sách thiết bị</h1>
      <div class="btn-group float-right">
        <button
          class="font-medium f12 btn btn-outline-secondary"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Import Files"
          v-if="dataPermission.includes('CNPS_CFG_UPSERT_POLICY')"
          @click="$router.push({ name: 'createPolicyDevice' })"
        >
          <i class="bx bx-plus"></i><span>&nbsp;</span>Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.categoryCode"
              :options="deviceCatData"
              placeholder="Loại thiết bị"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(type)="{ item }">
                {{ item.type | transformData(Config.optionType) }}
              </template>
              <template #cell(typeAppendix)="{ item }">
                {{ item.typeAppendix | transformData(Config.typeAppendix) }}
              </template>
              <template #cell(action)="{ item }">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    @click="$router.push('/policy-device/' + item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="$router.push('/policy-device/edit/' + item.id)"
                    v-if="dataPermission.includes('CNPS_CFG_UPSERT_POLICY')"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                  <b-dropdown-item @click="changeStatus(item.id)" class="dropdown-item"
                    ><span>&nbsp;</span>Đổi trạng thái
                    {{ item.status === 'ACTIVE' ? 'inactive' : 'active' }}
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  export default {
    name: 'policy-device',
    data() {
      return {
        Config,
        filterTable: [
          { key: 'index', label: 'STT', class: 'text-center' },
          { key: 'code', label: 'Mã chính sách', class: 'text-center' },
          { key: 'name', label: 'Tên chính sách' },
          { key: 'typeAppendix', label: 'Mã phụ lục', class: 'text-center' },
          { key: 'type', label: 'Cách tính' },
          { key: 'categoryCode', label: 'Loại thiết bị' },
          { key: 'priority', label: 'Ưu tiên' },
          { key: 'status', label: 'Trạng thái' },
          { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
        ],
        lists: [],
        showLoading: false,
        tbLoading: false,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        deviceCatData: [],
      }
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.fetchData()
      this.fetchCatDevice()
    },
    methods: {
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = cloneDeep(this.search)
          const response = await DeviceService.fetchPolicyDevice(params)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.data.count
          } else {
            this.lists = []
            this.pagination.total = 0
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      async fetchCatDevice() {
        const response = await DeviceService.typeDeviceConfig()
        this.deviceCatData = response.data.map(({ nickname, name }) => {
          return { id: nickname, text: name }
        })
      },
      async changeStatus(id) {
        try {
          this.showLoading = true
          const data = await DeviceService.changeStatePolicyDevice({ id })
          if (data.success) {
            this.showSuccessMx('Đổi trạng thái chính sách bảo hành thành công')
            this.fetchData()
          } else this.showFailMx(data.message)
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
